import { ReactComponent as ArrowRight } from 'assett/icons/arrow_right_claim_detail.svg';
import Button, { ButtonProps } from './Button';

import styled from 'styled-components';

const StyledButton = styled(Button)<ButtonProps>``;

const IconButton: React.FC<ButtonProps> = props => {
	return (
		<StyledButton
			type="button"
			variant="popoverButton"
			fullWidth={true}
			endIcon={<ArrowRight />}
			{...props}
			sx={{ borderRadius: 0, ...props.sx }}
		>
			{props.children}
		</StyledButton>
	);
};

export default IconButton;
